import {
  SAVE_MESSAGE,
  UPDATE_ACTIVE_SUPPORT_USER,
  SAVE_SUPPORT_USER_MESSAGES,
  SAVE_SUPPORT_USER_MORE_MESSAGES,
  SAVE_SUPPORT_USER_NEWER_MESSAGES,
  UPDATE_SUPPORT_MESSAGE_STATUS,
  SAVE_ACTIVE_SUPPORT_USER,
  CLEAR_ACTIVE_USER,
  SET_FILTER_MESSAGE_IDS,
  SET_FOCUSED_NATIVE_MESSAGE_ID,
} from '../actions/activeUser'
import { IS_NOT_AUTHENTICATED } from '../../authorization/actions/security'
import _ from 'lodash'

const initialState = {
  botActive: null,
  chatId: null,
  chatStatus: null,
  firstName: null,
  lastMessage: null,
  lastName: null,
  lastEventAt: null,
  openedAt: null,
  platform: null,
  postback: null,
  profilePicture: null,
  supportRequest: null,
  unreadMessage: null,
  unreadMessagesCount: null,
  userId: null,
  lastUserActionAt: null,
  messages: [],
  filterMessageIds: [],
  focusedNativeMessageId: null,
}

const updateMessage = (messages, message) => {
  let messagesCopy = _.cloneDeep(messages)

  messagesCopy = messagesCopy.map(msg => {
    if (msg?.nativeMessage?.includes(message.status.messageId)) {
      msg.status = message.status.status
    }
    return msg
  })
  return messagesCopy
}

const activeUser = (state = initialState, { type, payload }) => {
  switch (type) {
    case SAVE_ACTIVE_SUPPORT_USER:
      return {
        userId: payload.activeUser.userId,
        chatId: payload.activeUser.chatId,
        ...initialState,
        ...payload.activeUser,
        messages: state.messages,
      }

    case UPDATE_ACTIVE_SUPPORT_USER:
      const activeUser = _.omitBy(payload.activeUser, v => v === null)

      return {
        ...state,
        ...activeUser,
        messages: state.messages,
      }

    case SAVE_SUPPORT_USER_MESSAGES:
      return {
        ...state,
        messages: [...payload.messages].sort((a, b) => b.chatHistoryId - a.chatHistoryId),
      }

    case SAVE_SUPPORT_USER_MORE_MESSAGES: {
      const existingIds = new Set(state.messages.map(m => m.chatHistoryId))
      const newMessages = payload.messages
        .filter(m => !existingIds.has(m.chatHistoryId))
        .sort((a, b) => b.chatHistoryId - a.chatHistoryId)
      return {
        ...state,
        messages: [...state.messages, ...newMessages],
      }
    }

    case SAVE_SUPPORT_USER_NEWER_MESSAGES: {
      const existingIds = new Set(state.messages.map(m => m.chatHistoryId))
      const newerMessages = payload.messages
        .filter(m => !existingIds.has(m.chatHistoryId))
        .sort((a, b) => b.chatHistoryId - a.chatHistoryId)
      return {
        ...state,
        messages: [...newerMessages, ...state.messages],
      }
    }

    case SAVE_MESSAGE:
      return {
        ...state,
        messages: [payload.message, ...state.messages],
      }

    case UPDATE_SUPPORT_MESSAGE_STATUS:
      return {
        ...state,
        messages: [...updateMessage(state.messages, payload.message)],
      }

    case SET_FILTER_MESSAGE_IDS:
      return {
        ...state,
        filterMessageIds: payload.ids,
      }

    case SET_FOCUSED_NATIVE_MESSAGE_ID:
      return {
        ...state,
        focusedNativeMessageId: payload.id,
      }

    case CLEAR_ACTIVE_USER:
    case IS_NOT_AUTHENTICATED:
      return {
        ...initialState
      }

    default:
      return state
  }
}

export default activeUser
